import state from './auth.state';
import mutations from './auth.mutation';
import actions from './auth.action';
import getters from './auth.getter';
import { Module } from 'vuex';
import { IUserResponse, IUserLogined, Step1 } from '../types';

export enum authMutations {
    SET_TYPE_IDENTITY = 'SET_TYPE_IDENTITY',
    SET_USER_REGISTERED = 'SET_USER_REGISTERED',
    SET_LOGIN_RESULT = 'SET_LOGIN_RESULT',
    SET_USER_LOGINED = 'SET_USER_LOGINED',
    SET_STEP_1 = 'auth/SET_STEP_1',
    SET_STEP_2 = 'auth/SET_STEP_2',
    SET_STEP_3 = 'auth/SET_STEP_3',
}
export interface IAuthState {
    loginSuccess: boolean;
    typeIdentity?: string;
    userRegistered?: IUserResponse;
    userLogined: IUserLogined;
    step1?: Step1;
    step2?: Object;
    step3?: Object;
    typeDefault?: string;
    setNotifySuccess?: string;
}
export const auth: Module<IAuthState, any> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
